module.exports = __webpack_public_path__ + "img/index-security-bottom3.5ac26e57.svg";